import Joi from 'joi';
import _ from 'underscore';
import {
	api as apiRequest,
	batchApi as batchApiRequest
} from '@culture/common-helpers/request';
import { addCleanCache } from '@culture/common-helpers/params';

import Template from 'pageTemplates/nationalStreaming/main';

const NationalStreamingPage = (props) => <Template {...props} />;

const moviesFields = [
	'title',
	'name',
	'type',
	'thumbnailFile',
	'additionalThumbnailFile',
	'institute',
	'publishDate',
	'toDate',
	'rubrics'
];

const getMoviesByTypes = async (cleanCache) => {
	const movieTypes = [
		'performance',
		'concert',
		'lecture',
		'broadcast',
		'movie'
	];

	const [
		{ items: performance },
		{ items: concert },
		{ items: lecture },
		{ items: broadcast },
		{ items: movie }
	] = await batchApiRequest(
		movieTypes.map((type) =>
			apiRequest(
				'movies',
				addCleanCache(
					{
						bidType: 'nationalProject',
						statuses: ['published'],
						fields: moviesFields.join(),
						types: [type],
						sort: '-views',
						limit: 10,
						cached: true
					},
					cleanCache
				)
			)
		)
	);

	return {
		performance,
		concert,
		lecture,
		broadcast,
		movie
	};
};

const getRubricPage = (cleanCache) =>
	apiRequest(
		`rubricPages/${140}`,
		addCleanCache({ expand: ['rubric', 'blocks'] }, cleanCache)
	);

const getActualMovies = (cleanCache) =>
	apiRequest(
		'movies',
		addCleanCache(
			{
				bidType: 'nationalProject',
				statuses: ['published'],
				types: ['broadcast'],
				fields: moviesFields.join(),
				cached: true,
				publishDateFrom: new Date(),
				sort: 'publishDate',
				limit: 8
			},
			cleanCache
		)
	);

const getStreamingPlatforms = (cleanCache) =>
	apiRequest(
		'streamingPlatforms',
		addCleanCache(
			{
				bidType: 'nationalProject',
				sort: '-broadcastCount',
				fields: ['thumbnailFile', 'name', 'title', 'locale'].join(),
				limit: 10,
				cached: true
			},
			cleanCache
		)
	);

const getCounters = (cleanCache) =>
	apiRequest(
		'counters/national-streaming',
		addCleanCache({ cached: true }, cleanCache)
	);

export async function getServerSideProps({ query }) {
	const validationSchema = Joi.object().keys({
		cleanCache: Joi.boolean()
	});

	const params = Joi.attempt(query, validationSchema, {
		stripUnknown: true
	});

	const [
		[
			{ rubric, blocks },
			{ items: actualMovies },
			{ items: streamingPlatforms },
			counters
		],
		moviesByTypes
	] = await Promise.all([
		batchApiRequest([
			getRubricPage(params.cleanCache),
			getActualMovies(params.cleanCache),
			getStreamingPlatforms(params.cleanCache),
			getCounters(params.cleanCache)
		]),
		getMoviesByTypes(params.cleanCache)
	]);

	let archiveMovies = [];
	if (!actualMovies.length) {
		({ items: archiveMovies } = await apiRequest(
			'movies',
			addCleanCache(
				{
					bidType: 'nationalProject',
					statuses: ['published'],
					fields: moviesFields.join(),
					withVideo: true,
					cached: true,
					limit: 8
				},
				params.cleanCache
			)
		));
	}

	const indexedBlocks = _(blocks).indexBy('name');

	return {
		props: {
			blocks: indexedBlocks,
			actualMovies,
			archiveMovies,
			moviesByTypes,
			streamingPlatforms,
			rubric,
			counters
		}
	};
}

export default NationalStreamingPage;
